













import { Component, Provide, Vue } from "vue-property-decorator";
import router from "./router";
import PageHeader from "@/components/PageHeader.vue";
import PageFooter from "@/components/PageFooter.vue";
import { bootstrap, setOptions } from "vue-gtag";
import { GT_KEY } from "@/constants";
import ConfigDataService from "@/services/ConfigDataService";
import { Status } from "@/types";

const COOKIE_ACCEPT_KEY = "accept-cookies";

@Component({
  components: {
    PageHeader,
    PageFooter
  }
})
export default class App extends Vue {
  @Provide() private hasUserRespondedToGDPR = this.$cookies.isKey(
    COOKIE_ACCEPT_KEY
  );

  get isReady() {
    return this.$store.state.config.status === Status.ready;
  }

  mounted() {
    if (
      this.hasUserRespondedToGDPR &&
      this.$cookies.get(COOKIE_ACCEPT_KEY) === "true"
    ) {
      this.startTracking();
    }
    this.$store.commit("invalidateConfig");
    ConfigDataService.getDateRange()
      .then(response => this.$store.commit("dateRangeSuccess", response.data))
      .catch(error => this.$store.commit("dateRangeFail", error));
  }

  handleUserAcceptance(isAccepted: boolean) {
    this.hasUserRespondedToGDPR = true;
    this.$cookies.set("accept-cookies", isAccepted, "1y");
    if (isAccepted) {
      this.startTracking();
    }
  }

  startTracking() {
    setOptions({
      config: {
        id: GT_KEY,
        params: {
          send_page_view: false
        }
      },
      appName: "IFIS Trend Analytics Platform",
      pageTrackerScreenviewEnabled: true
    });

    bootstrap().then(() => {
      router.afterEach((to, from) => {
        Vue.prototype.$gtag.time({
          name: from.name ?? from.path,
          value: window.performance.now(),
          event_category: "page_time"
        });
        Vue.prototype.$gtag.pageview({
          page_path: to.path,
          page_title: to.name ?? to.path
        });
      });
    });
  }
}
